export default __webpack_public_path__ + "smop-favicon-182.d82a7cf84424c14d9c61c1acaef0f9a9.png";